import { OpticalData, TranslationData } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import EyeMeasurement from "./EyeMeasurement";

interface IProps {
  className?: string;
  opticalData: OpticalData;
  translations: TranslationData;
}

const PrescriptionMeasurements = ({ className, opticalData, translations }: IProps) => {
  const { left, right } = opticalData;

  return (
    <div className={cn("flex flex-col gap-3 p-3 text-[0.75rem] md:px-4", className)}>
      <div className="grid grid-cols-5 gap-4">
        <div className="col-span-1"></div>
        <div className="col-span-1">
          <p className="font-bold">
            {translations?.lensConfigurator?.lens_config_spherical_lens_title}
          </p>
          <p>{translations?.lensConfigurator?.lens_config_spherical_lens_subtitle}</p>
        </div>
        <div className="col-span-1">
          <p className="font-bold">
            {translations?.lensConfigurator?.lens_config_cylindrical_lens_title}
          </p>
          <p>{translations?.lensConfigurator?.lens_config_cylindrical_lens_subtitle}</p>
        </div>
        <div className="col-span-1">
          <p className="font-bold">{translations?.lensConfigurator?.lens_config_lens_axis_title}</p>
          <p>{translations?.lensConfigurator?.lens_config_lens_axis_subtitle}</p>
        </div>
        <div className="col-span-1">
          <p className="font-bold">
            {translations?.lensConfigurator?.lens_config_lens_addition_title}
          </p>
          <p>{translations?.lensConfigurator?.lens_config_lens_addition_subtitle}</p>
        </div>
      </div>
      <EyeMeasurement
        label={translations?.lensConfigurator?.lens_config_right_eye_title ?? ""}
        description={translations?.lensConfigurator?.lens_config_right_eye_subtitle ?? ""}
        values={{
          axis: right.axis,
          add: right.pupilSize,
          cyl: right.cylinderPower,
          sph: right.sphericalPower,
        }}
      />
      <EyeMeasurement
        label={translations?.lensConfigurator?.lens_config_left_eye_title ?? ""}
        description={translations?.lensConfigurator?.lens_config_left_eye_subtitle ?? ""}
        values={{
          axis: left.axis,
          add: left.pupilSize,
          cyl: left.cylinderPower,
          sph: left.sphericalPower,
        }}
      />
    </div>
  );
};

export default PrescriptionMeasurements;
